// extracted by mini-css-extract-plugin
module.exports = {"card":"ComplexDataLinkCard_card__9rKZh"};